/*
  BT Größenfinder (14.10.2026)
  Liest die Maßtabellen aus dem JSON im Snippet bt-groessenfinder, wählt die passende Tabelle
  (Variante „Version“ → Produkttitel → Standard), berechnet passende Größen nur aus den Tabellenwerten
  und übernimmt eine Größe auf Wunsch in die Größenauswahl. Keine erfundenen Regeln:
  Passen mehrere Größen, werden alle gezeigt.
*/
(function () {
  'use strict';

  var STORAGE_KEY = 'bt-gf-masse';

  var FELDER = {
    brust: { label: 'Brustumfang', hint: 'breiteste Stelle hinter den Vorderbeinen', min: 20, max: 120 },
    hals: { label: 'Halsumfang', hint: 'dort, wo das Halsband sitzt', min: 10, max: 80 },
    taille: { label: 'Taillenumfang', hint: 'schmalste Stelle, ca. Ende des Brustkorbs', min: 15, max: 110 },
    steg: { label: 'Bruststeglänge', hint: 'vom Brustbein durch die Vorderbeine nach hinten', min: 5, max: 60, optional: true },
    ruecken: { label: 'Rückenlänge', hint: 'vom Halsansatz bis zum Schwanzansatz', min: 10, max: 100 }
  };

  var FELDER_JE_KENNUNG = {
    easywalk: ['brust', 'hals', 'steg'],
    plus: ['brust', 'hals', 'taille'],
    paikka: ['ruecken', 'brust', 'hals'],
    halsband: ['hals'],
    nachmass: ['hals'],
    pomppa: ['ruecken', 'brust', 'hals', 'taille']
  };

  function esc(t) {
    return String(t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fmt(n) {
    return String(n).replace('.', ',');
  }

  function ladeMasse() {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function speichereMasse(werte) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(werte));
    } catch (e) {
      /* privater Modus o. Ä. – Finder funktioniert trotzdem */
    }
  }

  function inBereich(wert, bereich) {
    if (bereich[0] === null && bereich[1] === null) return true;
    var von = bereich[0] === null ? -Infinity : bereich[0];
    var bis = bereich[1] === null ? Infinity : bereich[1];
    return wert >= von && wert <= bis;
  }

  /* Variante „Version“ und Größen-Fieldset im Variant-Picker finden */
  function findeFieldset(form, namen) {
    var sets = form ? form.querySelectorAll('fieldset.variant-picker__option') : [];
    for (var i = 0; i < sets.length; i++) {
      var legend = sets[i].querySelector('legend');
      var name = legend ? legend.textContent.replace(':', '').trim().toLowerCase() : '';
      if (namen.indexOf(name) !== -1) return sets[i];
    }
    return null;
  }

  /* Größen-Optionswert normalisieren: „Gr. 40 (ca. 39–42 cm)“ → „40“, „Größe s“ → „S“ (15.10.2026) */
  function normGroesse(text) {
    return String(text || '')
      .replace(/\([^)]*\)/g, ' ')
      .replace(/^\s*(gr\.?|größe|groesse|size)\s*/i, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase();
  }

  /* Index des passenden Optionswerts: 1. exakt, 2. normalisiert gleich, 3. Größe als eigenes Wort – nur wenn eindeutig.
     Ganze Wörter: „S“ trifft nie „XS“. */
  function findeGroessenLabel(texte, groesse) {
    var ziel = String(groesse || '').trim();
    var zielNorm = normGroesse(ziel);
    if (!zielNorm) return -1;
    var i;
    for (i = 0; i < texte.length; i++) if (String(texte[i]).trim() === ziel) return i;
    for (i = 0; i < texte.length; i++) if (normGroesse(texte[i]) === zielNorm) return i;
    var treffer = [];
    for (i = 0; i < texte.length; i++) {
      var woerter = normGroesse(texte[i]).split(/[\s\/,;|–-]+/);
      if (woerter.indexOf(zielNorm) !== -1) treffer.push(i);
    }
    return treffer.length === 1 ? treffer[0] : -1;
  }
  if (typeof window !== 'undefined') window.btFindeGroessenLabel = findeGroessenLabel;

  function gewaehlterWert(fieldset) {
    if (!fieldset) return null;
    var input = fieldset.querySelector('input:checked');
    if (!input) return null;
    var label = fieldset.querySelector('label[for="' + input.id + '"]');
    return (label ? label.textContent : input.value).trim();
  }

  function init(root) {
    var datenEl = root.querySelector('[data-bt-gf-data]');
    var dialog = root.querySelector('dialog');
    if (!datenEl || !dialog) return;

    var tabellen;
    try {
      tabellen = JSON.parse(datenEl.textContent);
    } catch (e) {
      return;
    }
    if (!tabellen.length) return;

    var section = root.closest('.shopify-section') || document;
    var sizeNamen = ['größe', 'zubehörgröße', 'size'];
    /* Immer frisch suchen: das Theme baut die Variantenauswahl nach jedem Wechsel neu auf */
    function groessenFeld() { return findeFieldset(section.querySelector('variant-picker'), sizeNamen); }
    function versionFeld() { return findeFieldset(section.querySelector('variant-picker'), ['version']); }
    var groessenSet = groessenFeld();
    var versionSet = versionFeld();
    var titel = (root.getAttribute('data-product-title') || '').toLowerCase();
    var festeGroesse = (root.getAttribute('data-fixed-size') || '').trim();
    if (!festeGroesse && !groessenFeld()) {
      var alleZeilen = [];
      tabellen.forEach(function (t) { alleZeilen = alleZeilen.concat(t.zeilen); });
      var numerisch = alleZeilen.length && alleZeilen.every(function (z) { return /^\d+$/.test(z.groesse); });
      if (numerisch) {
        var treffer = alleZeilen.filter(function (z) { return new RegExp('(^|\\D)' + z.groesse + '(\\D|$)').test(titel); });
        if (treffer.length) festeGroesse = treffer[0].groesse;
      }
    }

    /* Knopf direkt an die Größenauswahl setzen (Baymard: Größenhilfe an der Auswahl) */
    if (groessenSet) {
      groessenSet.appendChild(root);
    }

    /* Fenster an den Body hängen: das Theme gleicht die Variantenauswahl nach jedem Wechsel neu ab
       und würde ein offenes Fenster darin sonst schließen */
    dialog.id = dialog.id + '-aktiv';
    root.querySelector('[data-bt-gf-open]').setAttribute('aria-controls', dialog.id);
    document.body.appendChild(dialog);

    var form = dialog.querySelector('[data-bt-gf-form]');
    var ergebnis = dialog.querySelector('[data-bt-gf-result]');
    var gewaehltHinweis = root.querySelector('[data-bt-gf-chosen]');
    var eyebrow = dialog.querySelector('[data-bt-gf-tabletitle]');
    var werte = ladeMasse();
    var aktiv = null;

    function aktiveTabelle() {
      var version = gewaehlterWert(versionFeld());
      var t;
      if (version) {
        t = tabellen.filter(function (x) { return (x.versionen || []).indexOf(version) !== -1; })[0];
        if (t) return t;
      }
      t = tabellen.filter(function (x) {
        return x.titelEnthaelt && x.titelEnthaelt.split(',').some(function (wort) {
          wort = wort.trim().toLowerCase();
          return wort && titel.indexOf(wort) !== -1;
        });
      })[0];
      if (t) return t;
      return tabellen.filter(function (x) { return x.standard; })[0] || tabellen[0];
    }

    function zeigeNurTabelle(handle) {
      dialog.querySelectorAll('[data-bt-gf-table]').forEach(function (el) {
        el.hidden = el.getAttribute('data-bt-gf-table') !== handle;
      });
      document.querySelectorAll('[data-bt-gf-tables] [data-bt-gf-table]').forEach(function (el) {
        el.hidden = el.getAttribute('data-bt-gf-table') !== handle;
      });
    }

    /* Welche Versionen gibt es bei diesem Produkt wirklich? */
    var versionWerte = versionSet
      ? Array.prototype.map.call(versionSet.querySelectorAll('label'), function (l) { return l.textContent.trim(); })
      : [];
    var umschaltbar = tabellen.filter(function (t) {
      return (t.versionen || []).some(function (v) { return versionWerte.indexOf(v) !== -1; });
    });
    var hatUmschaltung = umschaltbar.length > 1;

    function kurzname(t) {
      var teile = (t.versionen || []).map(function (v) { return v.replace(/^BT EasyWalk®\s?/, '') || 'EasyWalk®'; });
      if (!teile.length) return t.titel;
      if (teile.length === 1 && teile[0] !== 'EasyWalk®') return 'EasyWalk® ' + teile[0];
      return teile.join(' / ');
    }

    function baueUmschaltung(ziel, handle, onWahl) {
      if (!ziel || !hatUmschaltung) return;
      var alt = ziel.querySelector(':scope > .bt-gf-switch');
      if (alt) alt.remove();
      var box = document.createElement('div');
      box.className = 'bt-gf-switch';
      box.innerHTML =
        '<span class="bt-gf-switch__label">Maße für:</span>' +
        '<span class="bt-gf-switch__chips" role="group" aria-label="Version wählen">' +
          umschaltbar.map(function (t) {
            return '<button type="button" class="bt-gf-switch__chip" data-handle="' + esc(t.handle) + '" aria-pressed="' + (t.handle === handle) + '">' + esc(kurzname(t)) + '</button>';
          }).join('') +
        '</span>' +
        '<span class="bt-gf-switch__hinweis">Die Maße hängen von der gewählten Version ab.</span>';
      box.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-handle]');
        if (!chip) return;
        var t = umschaltbar.filter(function (x) { return x.handle === chip.getAttribute('data-handle'); })[0];
        if (t) onWahl(t);
      });
      ziel.insertBefore(box, ziel.firstChild);
    }

    function waehleVersion(t) {
      var vf = versionFeld();
      var labels = vf ? vf.querySelectorAll('label') : [];
      for (var i = 0; i < labels.length; i++) {
        if ((t.versionen || []).indexOf(labels[i].textContent.trim()) !== -1) {
          labels[i].click();
          return;
        }
      }
    }

    /* Aufklappbereich „Maße & Größen“: Umschaltung zeigt nur die Tabelle an */
    function aktualisiereAkkordeon(handle) {
      document.querySelectorAll('[data-bt-gf-tables]').forEach(function (box) {
        box.classList.toggle('bt-gf-hat-switch', hatUmschaltung);
        baueUmschaltung(box, handle, function (t) {
          box.querySelectorAll('[data-bt-gf-table]').forEach(function (el) {
            el.hidden = el.getAttribute('data-bt-gf-table') !== t.handle;
          });
          box.querySelectorAll('.bt-gf-switch__chip').forEach(function (c) {
            c.setAttribute('aria-pressed', String(c.getAttribute('data-handle') === t.handle));
          });
        });
      });
    }

    function aktualisiereKnopf() {
      var unter = root.querySelector('.bt-gf__trigger-text span');
      if (!unter) return;
      if (festeGroesse) {
        unter.textContent = 'Passt Größe ' + festeGroesse + ' zu deinem Hund? Maße prüfen';
        return;
      }
      if (aktiv.kennung === 'nachmass') {
        unter.textContent = 'Halsumfang richtig messen und bei der Bestellung angeben';
        return;
      }
      if (!groessenFeld() && aktiv.zeilen.filter(function (z) { return !z.hinweis; }).length === 1) {
        unter.textContent = 'Passt das Halsband? Halsumfang prüfen';
        return;
      }
      unter.textContent = hatUmschaltung
        ? 'Maße für ' + kurzname(aktiv) + ' – passt sich deiner Version an'
        : 'Maße eingeben und passende Größe finden';
    }

    function baueFelder() {
      var felder = FELDER_JE_KENNUNG[aktiv.kennung] || ['brust', 'hals'];
      form.innerHTML = felder.map(function (key) {
        var f = FELDER[key];
        if (aktiv.kennung === 'pomppa' && key === 'taille') {
          f = Object.assign({}, f, { optional: true, hint: 'vor den Hinterbeinen' });
        }
        if (aktiv.kennung === 'nachmass' && key === 'hals') {
          f = Object.assign({}, f, { label: 'Halsumfang (eng gemessen)', hint: 'eng anliegend, wo das Halsband sitzen soll' });
        }
        var id = dialog.id + '-' + key;
        var wert = werte[key] ? String(werte[key]) : '';
        return (
          '<label class="bt-gf__feld" for="' + id + '">' +
            '<span class="bt-gf__feld-label">' + f.label + (f.optional ? ' <em>(optional)</em>' : '') + '</span>' +
            '<span class="bt-gf__feld-eingabe">' +
              '<input id="' + id + '" name="' + key + '" type="number" inputmode="decimal" step="0.5" min="' + f.min + '" max="' + f.max + '" value="' + wert + '" placeholder="–">' +
              '<span>cm</span>' +
            '</span>' +
            '<span class="bt-gf__feld-hint">' + f.hint + '</span>' +
          '</label>'
        );
      }).join('');
    }

    function leseWerte() {
      var res = {};
      form.querySelectorAll('input').forEach(function (inp) {
        var v = parseFloat(String(inp.value).replace(',', '.'));
        if (!isNaN(v) && v > 0) res[inp.name] = v;
      });
      return res;
    }

    function berechne(w) {
      var zeilen = aktiv.zeilen.filter(function (z) { return !z.hinweis; });
      if (aktiv.kennung === 'pomppa') {
        return zeilen.filter(function (z) {
          var ok = true;
          if (w.ruecken) ok = ok && inBereich(w.ruecken, z.rueckenBereich);
          if (w.brust) ok = ok && inBereich(w.brust, z.brust);
          if (w.hals) ok = ok && inBereich(w.hals, z.hals);
          if (w.taille) ok = ok && inBereich(w.taille, z.taille);
          return ok;
        });
      }
      if (aktiv.kennung === 'paikka') {
        /* Werte der PAIKKA-Tabelle sind Maximalwerte; Rücken lässt sich um bis zu 5 cm kürzen (Herstellerangabe) */
        return zeilen.filter(function (z) {
          var ok = true;
          if (w.ruecken) ok = ok && w.ruecken <= z.ruecken && w.ruecken >= z.ruecken - 5;
          if (w.brust) ok = ok && w.brust <= z.brust[1];
          if (w.hals) ok = ok && w.hals <= z.hals[1];
          return ok;
        });
      }
      return zeilen.filter(function (z) {
        var ok = true;
        if (w.brust) ok = ok && inBereich(w.brust, z.brust);
        if (w.hals) ok = ok && inBereich(w.hals, z.hals);
        if (w.taille && aktiv.kennung === 'plus') ok = ok && inBereich(w.taille, z.taille);
        return ok;
      });
    }

    function pflichtFelderGefuellt(w) {
      var felder = FELDER_JE_KENNUNG[aktiv.kennung] || ['brust', 'hals'];
      return felder.every(function (k) { return FELDER[k].optional || (aktiv.kennung === 'pomppa' && k === 'taille') || w[k]; });
    }

    function balken(wert, bereich) {
      if (!wert || bereich[0] === null || bereich[1] === null) return '';
      var pct = Math.max(0, Math.min(100, ((wert - bereich[0]) / (bereich[1] - bereich[0])) * 100));
      return (
        '<span class="bt-gf__balken" aria-hidden="true">' +
          '<span class="bt-gf__balken-punkt" style="left:' + pct.toFixed(1) + '%"></span>' +
        '</span>'
      );
    }

    function karte(z, w) {
      var details = [];
      if (z.hals[1] !== null) details.push('Hals ' + (z.hals[0] !== null ? fmt(z.hals[0]) + '–' : 'bis ') + fmt(z.hals[1]) + ' cm');
      if (z.brust[1] !== null) details.push('Brust ' + (z.brust[0] !== null ? fmt(z.brust[0]) + '–' : 'bis ') + fmt(z.brust[1]) + ' cm');
      if (aktiv.kennung === 'plus' && z.taille[1] !== null) details.push('Taille ' + fmt(z.taille[0]) + '–' + fmt(z.taille[1]) + ' cm');
      if (z.steg !== null) details.push('Bruststeg ' + fmt(z.steg) + ' cm');
      if (z.rueckenBereich && z.rueckenBereich[1] !== null) details.push('Rücken ' + fmt(z.rueckenBereich[0]) + '–' + fmt(z.rueckenBereich[1]) + ' cm');
      else if (z.ruecken !== null) details.push('Rücken ' + fmt(z.ruecken) + ' cm');
      if (aktiv.kennung === 'pomppa' && z.taille[1] !== null) details.push('Taille ' + fmt(z.taille[0]) + '–' + fmt(z.taille[1]) + ' cm');
      return (
        '<li class="bt-gf__karte">' +
          '<div class="bt-gf__karte-kopf">' +
            '<span class="bt-gf__groesse">' + esc(z.groesse) + '</span>' +
            (festeGroesse ? '' : groessenFeld()
              ? '<button type="button" class="bt-gf__waehlen" data-bt-gf-choose="' + esc(z.groesse) + '">Größe ' + esc(z.groesse) + ' wählen</button>'
              : '<span class="bt-gf__optionen-hinweis">Größe ' + esc(z.groesse) + (root.getAttribute('data-konfigurator') ? ' im Konfigurator wählen' : ' bei den Optionen wählen') + '</span>') +
          '</div>' +
          (aktiv.kennung === 'halsband' && w.hals ? '<span class="bt-gf__balken-label">Halsumfang im Bereich der Größe</span>' + balken(w.hals, z.hals) : '') +
          (aktiv.kennung !== 'paikka' && aktiv.kennung !== 'halsband' && w.brust ? '<span class="bt-gf__balken-label">Brustumfang im Verstellbereich</span>' + balken(w.brust, z.brust) : '') +
          '<p class="bt-gf__details">' + details.join(' · ') + '</p>' +
        '</li>'
      );
    }

    function render() {
      var w = leseWerte();
      werte = Object.assign({}, werte, w);
      speichereMasse(werte);

      if (!pflichtFelderGefuellt(w)) {
        ergebnis.innerHTML = '';
        return;
      }

      var treffer = berechne(w);
      var html = '';
      var zeilenMitMass = aktiv.zeilen.filter(function (z) { return !z.hinweis; });

      if (aktiv.kennung === 'nachmass') {
        ergebnis.innerHTML =
          '<div class="bt-gf__meldung"><strong>Trag bei der Bestellung ein: Halsumfang ' + fmt(w.hals) + ' cm</strong>' +
          (aktiv.tipp ? '<p>' + esc(aktiv.tipp) + '</p>' : '') + '</div>';
        return;
      }

      if (!festeGroesse && !groessenFeld() && zeilenMitMass.length === 1) {
        var z1 = zeilenMitMass[0];
        var bereich = fmt(z1.hals[0]) + '–' + fmt(z1.hals[1]) + ' cm';
        ergebnis.innerHTML = treffer.length
          ? '<p class="bt-gf__ergebnis-titel">✓ Passt zu deinem Halsumfang (verstellbar ' + bereich + ')</p>'
          : '<div class="bt-gf__meldung"><strong>Passt laut Maßangabe nicht (verstellbar ' + bereich + ').</strong><p>Unsicher? <a href="/pages/contact">Schreib uns</a>.</p></div>';
        return;
      }

      if (festeGroesse) {
        var passt = treffer.filter(function (z) { return z.groesse === festeGroesse; })[0];
        if (passt) {
          html = '<p class="bt-gf__ergebnis-titel">✓ Größe ' + esc(festeGroesse) + ' passt zu deinen Maßen</p>' +
            '<ul class="bt-gf__karten" role="list">' + karte(passt, w) + '</ul>';
        } else {
          html = '<div class="bt-gf__meldung"><strong>Größe ' + esc(festeGroesse) + ' passt laut Maßtabelle nicht zu deinen Maßen.</strong>' +
            (treffer.length ? '<p>Passend wäre: ' + treffer.map(function (z) { return esc(z.groesse); }).join(', ') + '. Dieses Stück gibt es nur in Größe ' + esc(festeGroesse) + '.</p>' : '') +
            '<p>Unsicher? <a href="/pages/contact">Schreib uns</a>.</p></div>';
        }
        ergebnis.innerHTML = html;
        return;
      }

      if (!treffer.length) {
        html =
          '<div class="bt-gf__meldung">' +
            '<strong>Keine Größe passt zu allen eingegebenen Maßen.</strong>' +
            '<p>Prüf die Werte bitte noch einmal oder <a href="/pages/contact">schreib uns</a> – wir schauen gemeinsam.</p>' +
          '</div>';
      } else {
        var titelText = treffer.length === 1
          ? 'Passende Größe'
          : treffer.length + ' Größen passen zu deinen Maßen';
        html = '<p class="bt-gf__ergebnis-titel">' + titelText + '</p>';

        if (treffer.length > 1 && aktiv.kennung === 'easywalk' && w.steg) {
          var naechste = treffer.slice().sort(function (a, b) { return Math.abs(a.steg - w.steg) - Math.abs(b.steg - w.steg); })[0];
          html += '<p class="bt-gf__info">Dein Bruststeg (' + fmt(w.steg) + ' cm) liegt am nächsten an Größe <strong>' + esc(naechste.groesse) + '</strong> (' + fmt(naechste.steg) + ' cm).</p>';
        }
        if (treffer.length > 1 && aktiv.tipp) {
          html += '<p class="bt-gf__info">' + esc(aktiv.tipp) + '</p>';
        }
        if (treffer.length > 1 && !aktiv.tipp && !(aktiv.kennung === 'easywalk' && w.steg)) {
          html += '<p class="bt-gf__info">Die Größen überschneiden sich. Unsicher, welche besser sitzt? <a href="/pages/contact">Schreib uns</a>.</p>';
        }
        html += '<ul class="bt-gf__karten" role="list">' + treffer.map(function (z) { return karte(z, w); }).join('') + '</ul>';
      }
      ergebnis.innerHTML = html;
    }

    function waehleGroesse(groesse) {
      var gf = groessenFeld();
      if (!gf) return false;
      var labels = Array.prototype.slice.call(gf.querySelectorAll('label'));
      var label = findeGroessenLabel(labels.map(function (l) { return l.textContent; }), groesse);
      if (label === -1) return false;
      labels[label].click();
      return true;
    }

    function aktualisiere() {
      aktiv = aktiveTabelle();
      var tabTabelle = dialog.querySelector('[data-bt-gf-tab="tabelle"]');
      if (tabTabelle) tabTabelle.hidden = aktiv.zeilen.length === 0;
      if (eyebrow) eyebrow.textContent = hatUmschaltung ? 'Größenfinder' : aktiv.titel;
      zeigeNurTabelle(aktiv.handle);
      baueUmschaltung(dialog.querySelector('.bt-gf__inhalt'), aktiv.handle, function (t) {
        waehleVersion(t);
        aktiv = t;
        zeigeNurTabelle(t.handle);
        aktualisiere();
        /* Theme gleicht die Auswahl nach dem Wechsel ab – danach noch einmal sicher setzen */
        window.setTimeout(aktualisiere, 800);
      });
      baueFelder();
      render();
      aktualisiereAkkordeon(aktiv.handle);
      aktualisiereKnopf();
    }

    function zeigeSeite(name) {
      dialog.querySelectorAll('[data-bt-gf-tab]').forEach(function (tab) {
        tab.setAttribute('aria-selected', tab.getAttribute('data-bt-gf-tab') === name ? 'true' : 'false');
      });
      dialog.querySelectorAll('[data-bt-gf-page]').forEach(function (seite) {
        seite.hidden = seite.getAttribute('data-bt-gf-page') !== name;
      });
    }

    root.querySelector('[data-bt-gf-open]').addEventListener('click', function () {
      aktualisiere();
      zeigeSeite('finden');
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      document.documentElement.classList.add('bt-gf-offen');
    });

    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('bt-gf-offen');
    });

    dialog.querySelectorAll('[data-bt-gf-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { dialog.close(); });
    });

    /* Klick auf den abgedunkelten Hintergrund schließt */
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });

    dialog.querySelectorAll('[data-bt-gf-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () { zeigeSeite(tab.getAttribute('data-bt-gf-tab')); });
    });

    form.addEventListener('input', render);

    ergebnis.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bt-gf-choose]');
      if (!btn) return;
      var groesse = btn.getAttribute('data-bt-gf-choose');
      var ok = waehleGroesse(groesse);
      dialog.close();
      if (gewaehltHinweis) {
        var text = ok
          ? 'Größe ' + groesse + ' ausgewählt (' + aktiv.titel + ').'
          : 'Größe ' + groesse + ' ist bei diesem Produkt nicht wählbar.';
        /* Das Theme gleicht die Variantenauswahl nach dem Wechsel neu ab – Hinweis danach setzen */
        window.setTimeout(function () {
          gewaehltHinweis.hidden = false;
          gewaehltHinweis.textContent = text;
        }, 700);
      }
    });

    /* Version gewechselt → passende Tabelle */
    if (versionSet) {
      section.addEventListener('change', function (e) {
        var fs = e.target.closest && e.target.closest('fieldset');
        if (!fs || fs !== versionFeld()) return;
        window.setTimeout(function () {
          aktiv = aktiveTabelle();
          zeigeNurTabelle(aktiv.handle);
          aktualisiereAkkordeon(aktiv.handle);
          aktualisiereKnopf();
        }, 800);
      });
    }

    /* Service-Kachel „Hilfe bei der Größe“ nur bei Produkten mit Größenfinder (Tom 14.10.): einblenden und Finder öffnen */
    document.querySelectorAll('[data-bt-sk-groesse]').forEach(function (link) {
      var kachel = link.closest('.bt-sk__item');
      if (kachel) kachel.hidden = false;
      link.addEventListener('click', function (e) {
        e.preventDefault();
        root.querySelector('[data-bt-gf-open]').click();
      });
    });

    /* Bei Version EasyWalk / GB / Plus: Link zum Vergleich weiter unten auf der Seite */
    var vergleich = document.querySelector('.bt-ew');
    if (versionSet && vergleich && !versionSet.querySelector('.bt-gf__vergleich')) {
      var link = document.createElement('a');
      link.href = '#';
      link.className = 'bt-gf__vergleich';
      link.textContent = 'Was ist der Unterschied?';
      link.addEventListener('click', function (e) {
        e.preventDefault();
        vergleich.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      var info = versionSet.querySelector('.variant-picker__option-info');
      (info || versionSet).appendChild(link);
    }

    aktiv = aktiveTabelle();
    zeigeNurTabelle(aktiv.handle);
    aktualisiereAkkordeon(aktiv.handle);
    aktualisiereKnopf();
  }

  function start() {
    document.querySelectorAll('[data-bt-gf]').forEach(function (root) {
      if (root.__btGf) return;
      root.__btGf = true;
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
